// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Z--z","fadeIn":"_--z","delay":"a_-z","recommendedSizeTooltip":"b_-z"};